// extracted by css-extract-rspack-plugin
export default {"root":"NALqQbEKQYIZGNg0","circular":"mfl_fnpDIukzbp2k","rounded":"NnOZMyTM1YTq9JdK","square":"o3gV6Rsm6QXiRK5V","img":"YRPQbg1ru_QofqVf","fallbackIcon":"qFzFt4ZcA70_2zpl"};